module.exports = __webpack_public_path__ + "img/login-logo.62dd7614.png";